 import React from 'react';
import "./DynamicTooltip.css";

const DynamicTooltip = ({ direction = 'top', children, text }) => {
  return (
    <div className="dtooltip-container">
      {children}
      <div className={`dtooltip dtooltip-${direction}`}>
        {text}
      </div>
    </div>
  );
};

export default DynamicTooltip;
